import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from '@app/components/layout/home.component';
import { AuthenticationGuard } from '@app/core/guards/authentication.guard';
import { DmsLoginComponent } from '@app/pages/dms-login/dms-login.component';
import { LogoutComponent } from '@app/pages/logout/logout.component';

const routes: Routes = [
	{
		path: 'open',
		loadChildren: () => import('./pages/public/module/public-page.module').then(m => m.PublicPageModule)
	},
	{
		path: 'dms-login',
		component: DmsLoginComponent
	},
	{
		// The MCP OAuth consent page. Outside HomeComponent so it renders without the app shell.
		path: 'mcp-consent',
		canActivate: [AuthenticationGuard],
		loadChildren: () => import('./pages/mcp-consent/mcp-consent.routes').then(m => m.MCP_CONSENT_ROUTES)
	},
	{
		path: 'logout',
		canActivate: [AuthenticationGuard],
		component: LogoutComponent
	},
	{
		path: '',
		loadChildren: () => import('./pages/login/module/login-page.module').then(m => m.LoginPageModule)
	},
	{
		path: '',
		component: HomeComponent,
		canActivate: [AuthenticationGuard],
		children: [
			{
				path: 'notifications-settings',
				// loadChildren: () => import('./pages/notifications-settings/notifications-settings.module').then(m => m.NotificationsSettingsModule)
				loadChildren: () =>
					import('./modules/views/notifications-settings/notifications-settings.module').then(
						m => m.NotificationsSettingsModule
					)
			},
			{
				path: 'mobile-dashboard', //TODO: Check if working properly for mobile after new dashboard implementation
				loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule)
			},
			{
				path: 'dashboard', //TODO: Change name when pushing it to Prod
				loadChildren: () => import('./pages/new-dashboard/modules/dashboard.module').then(m => m.NewDashboardModule)
			},
			{
				path: 'clients-and-matters',
				loadChildren: () =>
					import('./pages/clients-and-matters/module/clients-and-matters.module').then(m => m.ClientsAndMattersModule)
			},
			{
				path: 'management',
				redirectTo: 'finance-management' // TODO: this redirection is temporary, once the pi's will not contain the url in it, we will be able to remove this line.
			},
			{
				path: 'finance-management',
				// loadChildren: () => import('./pages/management/management.module').then(m => m.FinanceManagement)
				loadChildren: () => import('./modules/views/management/management.module').then(m => m.ManagementModule)
			},
			{
				path: 'organization',
				// loadChildren: () => import('./pages/organization/organization.module').then(m => m.OrganizationModule)
				loadChildren: () => import('./pages/organization/module/organization.module').then(m => m.OrganizationModule)
			},
			{
				path: 'reports',
				// loadChildren: () => import('./pages/reports/reports.module').then(m => m.ReportsModule)
				loadChildren: () => import('./modules/views/reports/modules/reports.module').then(m => m.ReportsModule)
			},
			{
				path: 'documents-management',
				loadChildren: () => import('./pages/library/library.module').then(m => m.LibraryModule)
			},
			{
				// TODO: Enabled only in Dev for now
				path: 'new-matter',
				loadChildren: () => import('./pages/new-matter/modules/new-matter.module').then(m => m.NewMatterModule)
			},
			{
				path: 'tasks',
				loadChildren: () => import('./pages/tasks/modules/tasks.module').then(m => m.TasksModule)
			},
			{
				path: 'personal-settings',
				loadChildren: () =>
					import('./pages/personal-settings/module/personal-settings.module').then(m => m.PersonalSettingsModule)
			}
		]
	},
	{
		path: '**',
		redirectTo: ''
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {}
